import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const RouteTracker = () => {
  const location = useLocation();

  const userEmail = localStorage.getItem('user-email');

  useEffect(() => {
    const email =
      localStorage.getItem("custom-email") ||
      localStorage.getItem("ms-email") ||
      "Unknown";

    // Call your backend
    fetch("/api/log/pageview", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        userEmail,
        path: location.pathname,
        timestamp: new Date().toISOString()
      })
    });
  }, [location.pathname]); // Fires whenever the user changes route

  return null;
};

export default RouteTracker;
